/**
 * Imports various UI element modules and exports them as a single object.
 * This allows for easy access to all UI element functions from a single import.
 */

import * as cards from './cards.js';
import * as info from './info.js';
import * as dropdown from './dropdown.js';
import * as select from './select.js';
import * as tables from './tables.js';
import * as radio from './radio.js';
import * as spinner from './spinner.js';
import * as rank_list from './rank_list.js';

export default {
    cards,
    info,
    dropdown,
    select,
    tables,
    radio,
    spinner,
    rank_list,
};
